// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__118Fs","title":"ClientInsurance_title__3PlsA","itemText":"ClientInsurance_itemText__1Fkc4"};